export default __webpack_public_path__ + "static/img_featured_placeholder-5c5802dccdb2f4a9089f1f888c69849c.jpg";